export default __webpack_public_path__ + "static/TSD_Inner_Page_3-b5cdb80bf165e5506865f63a43983b93.png";